import {forwardRef, React, useImperativeHandle, useRef} from "react";
import logo from "../logobp3hijau1.png";
import { UserCircleIcon } from "@heroicons/react/solid";
import { decrypt } from "./shares/GlobalFunction";
import axiosInstance from "./shares/axiosConfig.js";
import Camera from "./shares/Camera.js";
import {API_URL_PHOTO } from "../constants.js";

const Header = ({ app_name }) => {
  return (
    <div className="login-container Bg-top-image sm:px-10 px-5 pt-2 z-0 fixed top-0 left-0 right-0 h-35 border-b-1"
      style={{backgroundImage: "linear-gradient(to bottom, #82CECC80, #FFFFFF)"}}
    >
      {/* <img alt="" style={{ margin: "5px", width: "120px"}} src={logo} /> */}
      <table>
        <tbody>
          <tr>
            <td>
              {/* <img alt="" style={{ margin: "5px", width: "70px" }} src={logo} /> */}
            </td>
            <td>
              <div className="sm:text-base text-xs">
                {/* <b>BALAI PENGELOLAAN PENGUJIAN PENDIDIKAN</b> */}
              </div>
              <div>
                <small>
                  {/* {app_name ? app_name : "ASESMEN BAKAT MINAT 2024"} */}
                </small>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const isWebcamAvailable = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    stream.getTracks().forEach((track) => track.stop());
    return true;
  } catch (err) {
    return false;
  }
};

export const Header2 = forwardRef(({ app_name, camera, mobile = false}, ref) => {
  let userData = localStorage.getItem("user");
  const webcamRef = useRef(null);
  
  // if (userData) {
  userData = JSON.parse(decrypt(userData));
  const capture = () => {
    if (isWebcamAvailable && webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot({
        width: 480,
        height: 320,
      });
      return imageSrc;
      // axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
      //   id_projek: userData.id_projek,
      //   id_siswa: userData.id_siswa,
      //   id_ujian: id_ujian,
      //   nopes: userData.nopes,
      //   image: imageSrc,
      // });
    } else {
      console.error("Webcam reference is null");
      return null
    }
  };
  // }
  useImperativeHandle(ref, () => ({
    capture,
  }));
  if (!mobile){
    return (
      <div className="flex justify-between gap-2 Bg-top-image sm:px-10 px-5 pt-2 z-0 fixed top-0 left-0 right-0 h-35 border-b-1">
        <div>
          {" "}
          <img alt="" style={{ margin: "5px", width: "120px"}} src={logo} />
        </div>
        <div className="w-full mt-5 pl-2 hidden sm:block">
          <div className="sm:text-base text-base">
            {/* <b>BALAI PENGELOLAAN PENGUJIAN PENDIDIKAN</b> */}
          </div>
          <div>
            {/* <small>{app_name ? app_name : "ASESMEN BAKAT MINAT"}</small> */}
          </div>
        </div>
        {camera !== 0 && camera && (
          <div className="absolute left-1/2 top-[0%] transform -translate-x-1/2 mb-10">
            <Camera webcamRef={webcamRef} header={true} />
          </div>
        )}
        {
          <div className="flex flex-col text-right gap-1 whitespace-nowrap text-sm mt-6">
              <span className="text-sm font-bold">{userData.nama_siswa}</span>
              <span className="text-xs">{userData.nopes}</span>
          </div>
        }
      </div>
    );
  }else{
    return (
      <div className="login-container flex flex-row Bg-top-image sm:px-10 px-5 pt-2 z-0 fixed top-0 left-0 right-0 h-35 border-b-1"
      style={{backgroundImage: "linear-gradient(to bottom, #82CECC80, #FFFFFF)"}}
    >
      {/* <img alt="" style={{ margin: "5px", width: "120px"}} src={logo} /> */}
      {camera !== 0 && camera && (
        <div className="relative bottom-[7%]">
          <Camera webcamRef={webcamRef} header={true} />
        </div>
      )}
      {
        <div className="flex flex-col text-left gap-1 whitespace-nowrap text-black text-sm mt-6 ml-4">
            <span className="text-sm font-bold">{userData.nama_siswa}</span>
            <span className="text-xs">{userData.nopes}</span>
        </div>
      }
    </div>
    );
  }
});

export default Header;
